import { Ionicons } from '@expo/vector-icons';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import colors from '../theme';
import { SocialProvider } from '../services/firebaseAuth';

type Props = {
  disabled?: boolean;
  onPress: (provider: SocialProvider) => void;
};

const buttons: Array<{ provider: SocialProvider; label: string; icon: keyof typeof Ionicons.glyphMap }> = [
  { provider: 'google', label: 'Google', icon: 'logo-google' },
  { provider: 'apple', label: 'Apple', icon: 'logo-apple' },
  { provider: 'facebook', label: 'Facebook', icon: 'logo-facebook' },
];

const socialLoginEnabled = false;

export default function SocialLoginButtons({ disabled, onPress }: Props) {
  if (!socialLoginEnabled) {
    return null;
  }

  return (
    <View style={styles.wrap}>
      <View style={styles.dividerRow}>
        <View style={styles.divider} />
        <Text style={styles.dividerText}>hoặc đăng nhập với</Text>
        <View style={styles.divider} />
      </View>
      <View style={styles.row}>
        {buttons.map((button) => (
          <Pressable
            key={button.provider}
            style={[styles.button, disabled && styles.buttonDisabled]}
            onPress={() => onPress(button.provider)}
            disabled={disabled}
          >
            <Ionicons name={button.icon} size={20} color={colors.textPrimary} />
            <Text style={styles.buttonText}>{button.label}</Text>
          </Pressable>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    marginTop: 16,
  },
  dividerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  divider: {
    flex: 1,
    height: 1,
    backgroundColor: colors.border,
  },
  dividerText: {
    color: colors.textSecondary,
    fontSize: 12,
    fontWeight: '700',
  },
  row: {
    gap: 10,
  },
  button: {
    height: 44,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.buttonText,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  buttonDisabled: {
    opacity: 0.62,
  },
  buttonText: {
    color: colors.textPrimary,
    fontSize: 13,
    fontWeight: '900',
  },
});
